export { getCommonServerSideProps as getServerSideProps } from '../../../utils/commonPrerender';
